import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-search-top-button',
  templateUrl: './search-top-button.component.html',
  styleUrls: ['./search-top-button.component.scss'],
})
export class SearchTopButtonComponent {
  @Input() isMobile = false;

  @Output() scrollToTop = new EventEmitter<any>();

  constructor(private translateService: TranslateService) {}

  goToTop() {
    this.scrollToTop.emit();
  }
}
